import React from "react";
import SidebarItem from "../SidebarItem";

export function SidebarItemWrap({ item, charge, selectedDiet, selectedExclusions, handleMealChange, handleDeleteItem }) {
  return (
    <SidebarItem
      image={item.image}
      excluded={typeof item.excluded !== "undefined" ? item.excluded : false}
      title={item.title}
      tags={item.tags}
      quantity={item.quantity}
      id={item.id}
      key={item.id}
      mealBoughtQuantity={item.mealBoughtQuantity}
      stockCapacity={item.stockCapacity}
      handleMealChange={handleMealChange}
      handleDeleteItem={handleDeleteItem}
      selectedExclusions={selectedExclusions}
      selectedDiet={selectedDiet}
      images={item.images}
      charge={charge}
    />
  );
}
